<app-section #parentSection
             [formConfig]="formConfig"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [title]="title"
             [key]="key"
             [class]="sectionClass"
             [verifyDataVisible]="verifyDataVisible"
             [editMode]="true">

    <ng-template #section>

        <app-section-data-presentation *ngIf="previewMode"
                                       [parentSection]="parentSection"
                                       [formGroup]="formGroup"
                                       [formConfig]="formConfig"
                                       [displayedFields]="dataPresentationFields">
        </app-section-data-presentation>

        <ng-container *ngIf="!isNext; else nextLayout">
            <div class="col" [ngClass]="{'col-preview-mode': previewMode}">
                <div *ngIf="canFieldDisplayed(consts.PARKING_PLACE)" class="section__component col-50">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.PARKING_PLACE]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.PARKING_PLACE, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PARKING_PLACE)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-select>
                </div>

                <div *ngIf="canFieldDisplayed(consts.USAGE_TYPE)" class="section__component col-50">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.USAGE_TYPE]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.USAGE_TYPE, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.USAGE_TYPE)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-select>
                </div>

                <div *ngIf="isFieldVisible(consts.AVG_MILEAGE_PER_YEAR)" class="section__component col-50">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.AVG_MILEAGE_PER_YEAR]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.AVG_MILEAGE_PER_YEAR, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.AVG_MILEAGE_PER_YEAR)]"
                            (markAsDirty)="markAsDirty($event)"

                    >
                    </app-select>
                </div>

                <div *ngIf="canFieldDisplayed(consts.IS_ABROAD)" class="section__component col-50">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.IS_ABROAD]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.IS_ABROAD, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_ABROAD)]"
                            (markAsDirty)="markAsDirty($event)"

                    >
                    </app-select>
                </div>

                <div *ngIf="isFieldVisible(consts.ACTUAL_MILEAGE)" class="section__component col-50">
                    <app-text-field [bean]="bean"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.ACTUAL_MILEAGE]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.ACTUAL_MILEAGE, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.ACTUAL_MILEAGE)]"
                                    (markAsDirty)="markAsDirty($event)"
                    >
                    </app-text-field>
                </div>

                <div *ngIf="!isFieldTypeButtonToggle(consts.ABROAD_IMPORTED) && isFieldVisible(consts.ABROAD_IMPORTED)" class="section__component col-50">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.ABROAD_IMPORTED]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.ABROAD_IMPORTED, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.ABROAD_IMPORTED)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-select>
                </div>
            </div>

            <div class="col" [ngClass]="{'col-preview-mode': previewMode}">
                <div *ngIf="!isFieldTypeButtonToggle(consts.VEHICLE_CONDITION) && canFieldDisplayed(consts.VEHICLE_CONDITION)" class="section__component col-50">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.VEHICLE_CONDITION]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.VEHICLE_CONDITION, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.VEHICLE_CONDITION)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-select>
                </div>

                <div class="section__component col-50"
                     *ngIf="damageDescriptionAllowed">
                    <app-textarea
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.DAMAGE_DESCRIPTION]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.DAMAGE_DESCRIPTION, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.DAMAGE_DESCRIPTION)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-textarea>
                </div>
            </div>

            <div class="col" [ngClass]="{'col-preview-mode': previewMode}">
                <div *ngIf="isFieldVisible(consts.FIRST_REGISTRATION_DATE)"
                     class="section__component col-50 datepicker-component">
                    <app-material-datepicker [errorsMap]="formFactoryService.errorsMap"
                                             [control]="formGroup.controls[consts.FIRST_REGISTRATION_DATE]"
                                             [fieldConfig]="formFactoryService.fieldConfig(consts.FIRST_REGISTRATION_DATE, formConfig)"
                                             [context]="formConfig.formKey"
                                             [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.FIRST_REGISTRATION_DATE)]"
                                             (markAsDirty)="markAsDirty($event)"></app-material-datepicker>
                </div>
            </div>

            <div class="col" [ngClass]="{'col-preview-mode': previewMode}">
                <div *ngIf="isFieldVisible(consts.PURCHASE_YEAR)" class="section__component col-50">
                    <app-material-year-picker
                        #purchaseYearField
                        [bean]="bean"
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.PURCHASE_YEAR]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.PURCHASE_YEAR, formConfig)"
                        [context]="formConfig.formKey"
                        [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PURCHASE_YEAR)]"
                        (markAsDirty)="markAsDirty($event)"
                    >
                    </app-material-year-picker>
                </div>

                <div *ngIf="purchaseMonthFieldVisible" class="section__component col-50">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [bean]="bean"
                            [control]="formGroup.controls[consts.PURCHASE_MONTH]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.PURCHASE_MONTH, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PURCHASE_MONTH)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-select>
                </div>
            </div>
        </ng-container>

        <ng-template #nextLayout>

            <div class="section__col"
                 [ngClass]="{
                    'col-preview-mode': previewMode,
                    'section__col--3': threeColumnsLayout,
                    'section__col--2': !threeColumnsLayout
                 }">
                <div *ngIf="isFieldVisible(consts.ACTUAL_MILEAGE)" class="section__field">
                    <app-text-field [bean]="bean"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.ACTUAL_MILEAGE]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.ACTUAL_MILEAGE, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.ACTUAL_MILEAGE)]"
                                    (markAsDirty)="markAsDirty($event)"
                    >
                    </app-text-field>
                </div>
                <div *ngIf="canFieldDisplayed(consts.PARKING_PLACE)" class="section__field">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.PARKING_PLACE]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.PARKING_PLACE, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PARKING_PLACE)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-select>
                </div>
                <div *ngIf="isFieldVisible(consts.AVG_MILEAGE_PER_YEAR)" class="section__field">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.AVG_MILEAGE_PER_YEAR]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.AVG_MILEAGE_PER_YEAR, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.AVG_MILEAGE_PER_YEAR)]"
                            (markAsDirty)="markAsDirty($event)"

                    >
                    </app-select>
                </div>
                <div *ngIf="canFieldDisplayed(consts.USAGE_TYPE)" class="section__field">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.USAGE_TYPE]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.USAGE_TYPE, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.USAGE_TYPE)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-select>
                </div>
                <div *ngIf="isFieldVisible(consts.FIRST_REGISTRATION_DATE)"
                     class="section__field datepicker-component">
                    <app-material-datepicker #firstRegistrationDateField
                                             [errorsMap]="formFactoryService.errorsMap"
                                             [control]="formGroup.controls[consts.FIRST_REGISTRATION_DATE]"
                                             [fieldConfig]="formFactoryService.fieldConfig(consts.FIRST_REGISTRATION_DATE, formConfig)"
                                             [context]="formConfig.formKey"
                                             [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.FIRST_REGISTRATION_DATE)]"
                                             (markAsDirty)="markAsDirty($event)"></app-material-datepicker>
                </div>
                <div *ngIf="canFieldDisplayed(consts.IS_ABROAD)" class="section__field">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.IS_ABROAD]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.IS_ABROAD, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_ABROAD)]"
                            (markAsDirty)="markAsDirty($event)"

                    >
                    </app-select>
                </div>

                <div *ngIf="isFieldVisible(consts.PURCHASE_YEAR)" class="section__field">
                    <app-material-year-picker
                        #purchaseYearField
                        [bean]="bean"
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.PURCHASE_YEAR]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.PURCHASE_YEAR, formConfig)"
                        [context]="formConfig.formKey"
                        [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PURCHASE_YEAR)]"
                        (markAsDirty)="markAsDirty($event)"
                    >
                    </app-material-year-picker>
                </div>

                <div *ngIf="purchaseMonthFieldVisible" class="section__field">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [bean]="bean"
                            [control]="formGroup.controls[consts.PURCHASE_MONTH]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.PURCHASE_MONTH, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PURCHASE_MONTH)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-select>
                </div>

                <div class="section__field"
                     *ngIf="damageDescriptionAllowed && !isNext">
                    <app-textarea
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.DAMAGE_DESCRIPTION]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.DAMAGE_DESCRIPTION, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.DAMAGE_DESCRIPTION)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-textarea>
                </div>
            </div>

        </ng-template>

        <div class="vehicle-questions"
            [ngClass]="{
                'vehicle-questions--inline-damage-description': inlineDamageDescriptionVisible
            }">

            <div class="col vehicle-use-section__condition" [ngClass]="{'col-preview-mode': previewMode}">
                <div *ngIf="isFieldTypeButtonToggle(consts.VEHICLE_CONDITION) && canFieldDisplayed(consts.VEHICLE_CONDITION)"
                     class="section__component vehicle-use-section__wide-button-toggle">
                    <app-button-toggle
                            [bean]="bean"
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.VEHICLE_CONDITION]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.VEHICLE_CONDITION, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.VEHICLE_CONDITION)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-button-toggle>
                </div>

                <div class="section__component col-50 vehicle-use-section__damage-description--next"
                     *ngIf="inlineDamageDescriptionVisible">
                    <app-textarea
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.DAMAGE_DESCRIPTION]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.DAMAGE_DESCRIPTION, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.DAMAGE_DESCRIPTION)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-textarea>
                </div>
            </div>

            <div *ngIf="nonInlineDamageDescriptionVisible"
                 class="col"
                 [ngClass]="{'col-preview-mode': previewMode}">
                <div class="section__component">
                    <app-textarea
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.DAMAGE_DESCRIPTION]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.DAMAGE_DESCRIPTION, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.DAMAGE_DESCRIPTION)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-textarea>
                </div>
            </div>

            <div class="col" [ngClass]="{'col-preview-mode': previewMode}">
                <div *ngIf="canFieldDisplayed(consts.IS_LEFT_HAND_DRIVE)" class="section__component vehicle-use-section__wide-button-toggle">
                    <app-radio *ngIf="isFieldTypeRadio(consts.IS_LEFT_HAND_DRIVE)"
                               [bean]="bean"
                               [errorsMap]="formFactoryService.errorsMap"
                               [control]="formGroup.controls[consts.IS_LEFT_HAND_DRIVE]"
                               [fieldConfig]="formFactoryService.fieldConfig(consts.IS_LEFT_HAND_DRIVE, formConfig)"
                               [context]="formConfig.formKey"
                               [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_LEFT_HAND_DRIVE)]"
                               (markAsDirty)="markAsDirty($event)"
                    >
                    </app-radio>

                    <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.IS_LEFT_HAND_DRIVE)"
                                       [bean]="bean"
                                       [errorsMap]="formFactoryService.errorsMap"
                                       [control]="formGroup.controls[consts.IS_LEFT_HAND_DRIVE]"
                                       [fieldConfig]="formFactoryService.fieldConfig(consts.IS_LEFT_HAND_DRIVE, formConfig)"
                                       [context]="formConfig.formKey"
                                       [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_LEFT_HAND_DRIVE)]"
                                       (markAsDirty)="markAsDirty($event)"
                    >
                    </app-button-toggle>
                </div>
            </div>

            <ng-container *ngIf="!deviceService.isMobileDevice">
                <div *ngIf="isFieldVisible(consts.IS_VALID_CAR_INSPECTION)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div class="section__component">
                        <app-radio *ngIf="isFieldTypeRadio(consts.IS_VALID_CAR_INSPECTION)"
                                [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[consts.IS_VALID_CAR_INSPECTION]"
                                [fieldConfig]="formFactoryService.fieldConfig(consts.IS_VALID_CAR_INSPECTION, formConfig)"
                                [context]="formConfig.formKey"
                                [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_VALID_CAR_INSPECTION)]"
                                (markAsDirty)="markAsDirty($event)"
                        >
                        </app-radio>

                        <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.IS_VALID_CAR_INSPECTION)"
                                [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[consts.IS_VALID_CAR_INSPECTION]"
                                [fieldConfig]="formFactoryService.fieldConfig(consts.IS_VALID_CAR_INSPECTION, formConfig)"
                                [context]="formConfig.formKey"
                                [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_VALID_CAR_INSPECTION)]"
                                (markAsDirty)="markAsDirty($event)"
                        >
                        </app-button-toggle>
                    </div>
                </div>
                <div class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.IS_GAS_INSTALLATION)" class="section__component">
                        <app-radio *ngIf="isFieldTypeRadio(consts.IS_GAS_INSTALLATION)"
                                   [bean]="bean"
                                   [errorsMap]="formFactoryService.errorsMap"
                                   [control]="formGroup.controls[consts.IS_GAS_INSTALLATION]"
                                   [fieldConfig]="formFactoryService.fieldConfig(consts.IS_GAS_INSTALLATION, formConfig)"
                                   [context]="formConfig.formKey"
                                   [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_GAS_INSTALLATION)]"
                                   (markAsDirty)="markAsDirty($event)"
                        >
                        </app-radio>

                        <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.IS_GAS_INSTALLATION)"
                                            [bean]="bean"
                                            [errorsMap]="formFactoryService.errorsMap"
                                            [control]="formGroup.controls[consts.IS_GAS_INSTALLATION]"
                                            [fieldConfig]="formFactoryService.fieldConfig(consts.IS_GAS_INSTALLATION, formConfig)"
                                            [context]="formConfig.formKey"
                                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_GAS_INSTALLATION)]"
                                            (markAsDirty)="markAsDirty($event)"
                        >
                        </app-button-toggle>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="deviceService.isMobileDevice">
                <div *ngIf="isFieldVisible(consts.IS_VALID_CAR_INSPECTION)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div class="section__component">
                        <app-radio *ngIf="isFieldTypeRadio(consts.IS_VALID_CAR_INSPECTION)"
                                [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[consts.IS_VALID_CAR_INSPECTION]"
                                [fieldConfig]="formFactoryService.fieldConfig(consts.IS_VALID_CAR_INSPECTION, formConfig)"
                                [context]="formConfig.formKey"
                                [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_VALID_CAR_INSPECTION)]"
                                (markAsDirty)="markAsDirty($event)"
                        >
                        </app-radio>
                        <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.IS_VALID_CAR_INSPECTION)"
                                           [errorsMap]="formFactoryService.errorsMap"
                                           [control]="formGroup.controls[consts.IS_VALID_CAR_INSPECTION]"
                                           [fieldConfig]="formFactoryService.fieldConfig(consts.IS_VALID_CAR_INSPECTION, formConfig)"
                                           [context]="formConfig.formKey"
                                           [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_VALID_CAR_INSPECTION)]"
                                           (markAsDirty)="markAsDirty($event)"
                        >
                        </app-button-toggle>
                    </div>
                </div>

                <div class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.IS_GAS_INSTALLATION)" class="section__component">
                        <app-radio *ngIf="isFieldTypeRadio(consts.IS_GAS_INSTALLATION)"
                                   [bean]="bean"
                                   [errorsMap]="formFactoryService.errorsMap"
                                   [control]="formGroup.controls[consts.IS_GAS_INSTALLATION]"
                                   [fieldConfig]="formFactoryService.fieldConfig(consts.IS_GAS_INSTALLATION, formConfig)"
                                   [context]="formConfig.formKey"
                                   [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_GAS_INSTALLATION)]"
                                   (markAsDirty)="markAsDirty($event)"
                        >
                        </app-radio>
                        <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.IS_GAS_INSTALLATION)"
                                           [bean]="bean"
                                           [errorsMap]="formFactoryService.errorsMap"
                                           [control]="formGroup.controls[consts.IS_GAS_INSTALLATION]"
                                           [fieldConfig]="formFactoryService.fieldConfig(consts.IS_GAS_INSTALLATION, formConfig)"
                                           [context]="formConfig.formKey"
                                           [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_GAS_INSTALLATION)]"
                                           (markAsDirty)="markAsDirty($event)"
                        >
                        </app-button-toggle>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="isFieldVisible(consts.IS_LEASING)"
                 class="col" [ngClass]="{'col-preview-mode': previewMode}">
                <div class="section__component">
                    <app-radio *ngIf="isFieldTypeRadio(consts.IS_LEASING)"
                               [bean]="bean"
                               [errorsMap]="formFactoryService.errorsMap"
                               [control]="formGroup.controls[consts.IS_LEASING]"
                               [fieldConfig]="formFactoryService.fieldConfig(consts.IS_LEASING, formConfig)"
                               [context]="formConfig.formKey"
                               [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_LEASING)]"
                               (markAsDirty)="markAsDirty($event)"
                    >
                    </app-radio>

                    <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.IS_LEASING)"
                                       [bean]="bean"
                                       [errorsMap]="formFactoryService.errorsMap"
                                       [control]="formGroup.controls[consts.IS_LEASING]"
                                       [fieldConfig]="formFactoryService.fieldConfig(consts.IS_LEASING, formConfig)"
                                       [context]="formConfig.formKey"
                                       [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.IS_LEASING)]"
                                       (markAsDirty)="markAsDirty($event)"
                    >
                    </app-button-toggle>
                </div>
            </div>

            <div *ngIf="isFieldVisible(consts.ABROAD_IMPORTED)"
                 class="col"
                 [ngClass]="{'col-preview-mode': previewMode}">
                <div *ngIf="isFieldTypeButtonToggle(consts.ABROAD_IMPORTED)" class="section__component">
                    <app-button-toggle
                            [bean]="bean"
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.ABROAD_IMPORTED]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.ABROAD_IMPORTED, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.ABROAD_IMPORTED)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-button-toggle>
                </div>
            </div>

            <div *ngIf="abroadImportedTimeVisible && isFieldVisible(consts.ABROAD_IMPORTED_TIME)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                <div class="section__component vehicle-use-section__wide-button-toggle">
                    <app-button-toggle
                            [bean]="bean"
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.ABROAD_IMPORTED_TIME]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.ABROAD_IMPORTED_TIME, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.ABROAD_IMPORTED_TIME)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-button-toggle>
                </div>
            </div>

            <div *ngIf="vehicleCountryOfOriginFieldVisible && isFieldVisible(consts.COUNTRY_OF_ORIGIN)" class="col vehicle-questions__country-of-origin" [ngClass]="{'col-preview-mode': previewMode}">
                <div *ngIf="canFieldDisplayed(consts.COUNTRY_OF_ORIGIN)" class="section__component col-50">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.COUNTRY_OF_ORIGIN]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.COUNTRY_OF_ORIGIN, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.COUNTRY_OF_ORIGIN)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-select>
                </div>
            </div>

        </div>

    </ng-template>
</app-section>
